import { render, staticRenderFns } from "./kTom_index_buJia.vue?vue&type=template&id=4bdbcfdf&scoped=true&"
import script from "./kTom_index_buJia.vue?vue&type=script&lang=js&"
export * from "./kTom_index_buJia.vue?vue&type=script&lang=js&"
import style0 from "./kTom_index_buJia.vue?vue&type=style&index=0&id=4bdbcfdf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdbcfdf",
  null
  
)

export default component.exports